import { Component } from '@angular/core';
import { INoRowsOverlayAngularComp } from '@ag-grid-community/angular';

@Component({
  selector: 'ft-no-filter-data-overlay',
  templateUrl: './no-filter-data-overlay.component.html',
})
export class NoFilterDataOverLayComponent implements INoRowsOverlayAngularComp {
  searchKey: string;
  refresh(params): boolean {
    this.initializeValues(params);
    return true;
  }
  agInit(params): void {
    this.initializeValues(params);
  }

  initializeValues(params) {
    this.searchKey = params;
  }
}
